<svelte:options immutable={true}/>

<script lang="ts">
  import { Button, Form, FormGroup, FormText, Input, Label } from "sveltestrap";
  import type { OrganizationInfo } from "../helpers/orgTypes";
  import { setUnityCloudApiKey } from "../helpers/requests";
  import { orgStore } from "../stores";
  import Toast from "./Toast.svelte";

  export let org: OrganizationInfo;
  let apiKey: string | null;
  $: apiKey = org.apiKey ?? "";
  let loading: boolean = false;
  let openModal: boolean = false;

  const defaultMsg = `The key for ${org.name} has been successfully updated!`;
  let modalData: { msg: string; success: boolean } = {
    msg: defaultMsg,
    success: true,
  };

  async function handleSubmit(e: Event) {
    e.preventDefault();
    loading = true;
    const result = await setUnityCloudApiKey(org, apiKey);
    // replace the org key in the store
    if (result.code === 202) {
      org.apiKey = apiKey;
      orgStore.update(org);
      modalData = {
        msg: defaultMsg,
        success: true,
      };
    } else {
      openModal = true;
      modalData = { msg: result.message as string, success: false };
    }
    loading = false;
    openModal = true;
  }
</script>

<Form on:submit={handleSubmit}>
  <FormGroup>
    <Label for="apiKey">Unity Cloud API Key for {org?.name}</Label>
    <Input
      type="text"
      name="apiKey"
      id="apiKey"
      placeholder="Api Key"
      bind:value={apiKey}
      disabled={loading}
    />
    <FormText color="muted">
      You can get this key at the <a
        href="https://dashboard.unity3d.com/organizations"
        target="_blank">Project Dashboard</a
      >
      > DevOps > Settings > API Settings
    </FormText>
    <hr />
    <FormText color="muted">
      You also need a to add a <b>config file</b> in your repository. You can
      generate one in <a href="/generator" target="_blank">with our tool</a>.<br
      />
      There you will find information of how to set it up and where to store it.
    </FormText>
    <hr />
    <FormText color="muted">
        Read the <a href="/docs" target="_blank">installation guide</a> for more info.
    </FormText>
  </FormGroup>
  <Button
    color="dark"
    disabled={apiKey === "" || apiKey === org?.apiKey || loading}
    type="submit"
  >
    {#if loading}
      Loading...
    {:else}
      Save
    {/if}
  </Button>
  <Toast
    title={modalData.success ? "Successfully saved key" : "Error"}
    bind:isOpen={openModal}
    success={modalData.success}
  >
    {modalData.msg}
  </Toast>
</Form>
